import React from "react";

const coreService = process.env.REACT_APP_ORIGIN + "core-service/v1/core";

export function IDP({ onSucessCallback, onFailureCallback }) {
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectParam = params.get("redirect");
    const keyParam = params.get("key");

    // Check if redirect URL contains localhost with port
    if (redirectParam && redirectParam.includes("localhost:")) {
      window.location.replace(redirectParam);
      return;
    }

    const headers = new Headers();
    headers.append("key", keyParam);
    headers.append("appName", process.env.REACT_APP_NAME);
    headers.append("Content-Type", "application/json");

    fetch(`${coreService}/token`, {
      method: "GET",
      crossDomain: false,
      withCredentials: true,
      headers: headers
    })
      .then((res) => res.text())
      .then(
        () => {
          if (typeof onSucessCallback === "function") {
            onSucessCallback();
          }
          setTimeout(() => {
            window.location.replace(redirectParam || '/');
          }, 2000);
        },
        (error) => {
          console.log(error);
          setError(true);
          if (typeof onFailureCallback === "function") {
            onFailureCallback();
          }
        }
      );
  }, [onFailureCallback, onSucessCallback]);

  if (error) {
    return <div data-id="idpText">Your Request is not complete.</div>;
  }
  return <div data-id="idpText">Your request is in progress...</div>;
}
